var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('BaseBreadcrumb',{attrs:{"title":_vm.$vuetify.lang.t('$vuetify.DASHBOARD.SETTINGS'),"breadcrumbs":[
      {
        text: _vm.$vuetify.lang.t('$vuetify.DASHBOARD.SETTINGS_DESCRIPTION'),
        disabled: true
      }
    ]}}),_c('v-list',{staticClass:"list"},[_vm._l((_vm.subpages),function(page){return [_c('v-row',{key:page.name},[_c('v-icon',{staticClass:"pa-2",domProps:{"textContent":_vm._s(page.icon)}}),_c('a',{staticClass:"pa-2",staticStyle:{"color":"#007CAD"},attrs:{"href":page.to}},[_vm._v(_vm._s(page.name))])],1)]})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }